import { GraphPageState } from './../types';

export const setCurrentGraphId = (
  graphSet: GraphPageState,
  graphId: string | null,
): GraphPageState => {
  return { ...graphSet, currentGraphId: graphId };
};
